import React from 'react';
const RefundPolicy = () => {
  return <div className="w-full" data-id="element-447">
      {/* Header Section */}
      <section className="relative py-20 bg-[#1A5F7A]" data-id="element-448">
        <div className="container mx-auto px-4" data-id="element-449">
          <div className="text-center" data-id="element-450">
            <h1 className="text-4xl font-bold text-white mb-4" data-id="element-451">
              Refund Policy
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-452">
              Our fair and transparent refund terms
            </p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-16" data-id="element-453">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-454">
          <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-455">
            <h2 className="text-2xl font-bold text-[#1A5F7A] mb-6" data-id="element-456">
              Refund Policy – Realmpoint
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-457">
              Thank you for choosing Realmpoint. We value your trust and are
              committed to ensuring your complete satisfaction with our
              services. If you have any concerns about your service plan or
              purchase, we'll work quickly and fairly to resolve them.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-458">
              Cancellation & Refund Rights
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-459">
              You have the right to cancel your service plan within 14 days of
              purchase and receive a full refund. To do this, please contact us
              within the 14-day period, and we'll process your refund promptly.
            </p>
            <p className="text-gray-600 mb-8" data-id="element-460">
              If you cancel after 14 days but within 28 days of purchase, you
              may be eligible for a partial refund at our discretion, depending
              on any services already provided under your plan.
            </p>
            <p className="text-gray-600 mb-8" data-id="element-461">
              Please note that refunds or cancellations are not available after
              28 days from the purchase date. We recommend reviewing your
              service plan carefully and contacting us as soon as possible if
              you wish to cancel.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-462">
              How to Request a Refund
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-463">
              To request a refund, please get in touch with our team using the
              contact details below:
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-464">
              <li className="mb-2" data-id="element-465">Phone: 0800 055 4969</li>
              <li className="mb-2" data-id="element-466">Email: bijayathakur8098@gmail.com</li>
            </ul>
            <p className="text-gray-600 mb-8" data-id="element-467">
              We'll assess your request promptly and process any approved
              refunds. You'll receive confirmation once your refund has been
              completed.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-468">
              Payment Methods
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-469">
              Realmpoint accepts payments via:
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-470">
              <li className="mb-2" data-id="element-471">Phone card payments</li>
              <li className="mb-2" data-id="element-472">Online payments through our website</li>
              <li className="mb-2" data-id="element-473">
                Cheques by post (please contact us for details)
              </li>
              <li className="mb-2" data-id="element-474">BACS or Direct Debit</li>
            </ul>
            <p className="text-gray-600 mb-8" data-id="element-475">
              Your 14-day cancellation right applies regardless of payment
              method.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-476">
              Refund Processing
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-477">
              All refunds will be issued to the original payment method used at
              purchase. For security reasons, refunds cannot be made to
              alternative accounts or cards.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-478">
              Payment Follow-Up
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-479">
              After purchasing a plan, Realmpoint will contact you to confirm
              activation and inform you when payment will be processed. Please
              ensure sufficient funds are available. If payment fails, we'll
              contact you to confirm whether you wish to proceed. Without a
              timely response, your plan will be cancelled.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-480">
              Authorised Payments
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-481">
              Payments must be made by the plan holder or an authorised
              individual. We don't accept payments made under power of attorney
              or other third-party authorisations.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-482">
              Claims & Support
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-483">
              To book a repair or submit a claim, please contact us immediately:
            </p>
            <ul className="list-disc pl-6 mb-8 text-gray-600" data-id="element-484">
              <li className="mb-2" data-id="element-485">Phone: 0800 055 4969</li>
              <li className="mb-2" data-id="element-486">Email: bijayathakur8098@gmail.com</li>
            </ul>
            <p className="text-gray-600 mb-8" data-id="element-487">
              Our team will assist you and begin the repair process promptly.
            </p>
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-488">
              Dispute Resolution
            </h3>
            <p className="text-gray-600" data-id="element-489">
              If you have any issues related to payment or service, please
              contact Realmpoint first before raising a chargeback with your
              bank. We aim to resolve all concerns fairly and promptly.
              Initiating a chargeback without prior contact may delay your
              refund.
            </p>
          </div>
        </div>
      </section>
    </div>;
};
export default RefundPolicy;